
import { Column } from "primereact/column";
import MeaLink from "../../../../components/MeaLink";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import CreateSystemSchoolModal from "./CreateSystemSchoolModal";
import systemSchoolsAPI from "../../../../services/system_schools";

const SystemSchoolsListComponent = forwardRef((props, ref) => {
  const { selectedFields, showAddButton, showFilterButton } = props;
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();

  const schoolId = "";
  const trainingId = "";
  const accessToken = "";
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  const toastRef = useRef();
  //
  let selectedData = {
    name: selectedFields?.name ?? true,
    status: selectedFields?.status ?? true,
    createdAt: selectedFields?.createdAt ?? true,
    edit: selectedFields?.edit ?? true,
  };
  //
  //
  const queryList = systemSchoolsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //

  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <MeaButton
          label="Créer une école "
          icon="pi pi-plus"
          size="small"
          className="p-button mr-2 action"
          onClick={() => {
            createModalRef.current.show(() => {
              queryList.refetch();
            });
          }}
          data-pr-tooltip="Nouvelle école"
        />
      )}
    </div>
  );

  const handleToggleStatus = async (item) => {
    const nextStatus = item?.status === "BLOCKED" ? "ACTIVE" : "BLOCKED";
    try {
      await systemSchoolsAPI.UpdateStatus(
        schoolId,
        trainingId,
        accessToken,
        item?.id,
        nextStatus,
      );
      toastRef.current?.show({
        severity: "success",
        summary: "Succès",
        detail: `Statut mis à jour: ${nextStatus}`,
        life: 3000,
      });
      queryList.refetch();
    } catch (err) {
      toastRef.current?.show({
        severity: "error",
        summary: "Erreur",
        detail: "Impossible de modifier le statut de l'école.",
        life: 4000,
      });
    }
  };

  const confirmToggleStatus = (event, item) => {
    const nextStatus = item?.status === "BLOCKED" ? "ACTIVE" : "BLOCKED";
    confirmPopup({
      target: event.currentTarget,
      message: `Voulez-vous vraiment passer le statut à ${nextStatus} ?`,
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Confirmer",
      rejectLabel: "Annuler",
      acceptClassName: nextStatus === "BLOCKED" ? "p-button-danger" : "p-button-success",
      accept: () => handleToggleStatus(item),
    });
  };

  //
  return (
    <>
      <Toast ref={toastRef} />
      <ConfirmPopup />
      <CreateSystemSchoolModal
        ref={createModalRef}
        schoolId={schoolId}
        trainingId={trainingId}
      />
      <MeaDataTable
        query={queryList}
        serviceAPI={systemSchoolsAPI}
        names={{ pagination: "school", singular: "école", plural: "écoles" }}
        startToolbarTemplate={startToolbarTemplate}
        showFilterButton={showFilterButton}
        showDeleteButton={false}
        setPage={setPage}
        setPageSize={setPageSize}
        schoolId={schoolId}
        trainingId={trainingId}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        {selectedData.name && (
          <Column
            field="name"
            header="Ecole"
            editor={(options) => (
              <InputText
                type="text"
                value={options.value}
                onChange={(e) => options.editorCallback(e.target.value)}
              />
            )}
            body={(item) => (
              <MeaLink to={"/school/" + item.id}>{item.name}</MeaLink>
            )}
          ></Column>
        )}
        {selectedData.createdAt && (
          <Column field="created_at" header="Crée le"></Column>
        )}

        {selectedData.status && (
          <Column
            field="status"
            header="Statut"
            body={(item) => (
              <Tag
                value={item?.status || "UNKNOWN"}
                severity={item?.status === "BLOCKED" ? "danger" : "success"}
              />
            )}
          ></Column>
        )}

        {selectedData.edit && (
          <Column
            body={(item) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  aria-label="Filter"
                  onClick={() => {
                    //setSchool(item);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                />
                <MeaButton
                  label={item?.status === "BLOCKED" ? "Activer" : "Bloquer"}
                  icon={item?.status === "BLOCKED" ? "pi pi-check-circle" : "pi pi-ban"}
                  size="small"
                  className={
                    item?.status === "BLOCKED"
                      ? "p-button-success p-button-text"
                      : "p-button-danger p-button-text"
                  }
                  onClick={(event) => confirmToggleStatus(event, item)}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      {/*<UpdateSystemSchoolModal ref={updateModalRef} school={school} />*/}
    </>
  );
});

export default SystemSchoolsListComponent;
